import React, { PureComponent } from 'react'

import { imageUrl } from '@libs/appUrl'
import { noImg } from '@libs/postTools'

import cx from 'classnames'
import styles from './index.scss'

class LazyLoadImg extends PureComponent {
  static defaultProps = {
    width: 0,
    height: 0,
    className: '',
    style: {},
    src: '',
    alt: '',
    maxAlt: 50,
    handleLoaded: null,
    noImg,
  }

  constructor(props) {
    super(props)
    this._refs = {}
    this.noImg = props.noImg
    this.state = {
      src: this.noImg,
      dataSrc: props.src ? `${imageUrl(props.src)}` : props.src,
    }
    const minMargin = 500
    const vw =
      typeof window !== 'undefined'
        ? Math.max(window.document.documentElement.clientWidth, window.innerWidth || minMargin)
        : minMargin
    const vh =
      typeof window !== 'undefined'
        ? Math.max(window.document.documentElement.clientHeight, window.innerHeight || minMargin)
        : minMargin
    this.observer =
      typeof window !== 'undefined'
        ? new IntersectionObserver(this.lazyload, {
            root: this._refs.wrap,
            rootMargin: `${vh}px ${vw}px ${vh}px ${vw}px`,
            threshold: [0, 0.25, 0.5, 0.75, 1],
          })
        : null
  }

  handleRef = (name) => (node) => (this._refs[`${name}`] = this._refs[`${name}`] || node)

  onLoaded = (e = null, lazy = false) => {
    const { handleLoaded = null } = this.props
    if (lazy && handleLoaded) {
      handleLoaded({ e, img: e.target || this._refs.img, wrap: this._refs.wrap })
    }
  }

  onError = (e) => {
    if (e && e.target) {
      e.target.src = this.noImg
    } else {
      this._refs.img.src = this.noImg
    }
  }

  loadImage = (img) => {
    this.setState((state) => ({ ...state, src: state.dataSrc }))
    img.addEventListener('load', (e) => this.onLoaded(e, true))
  }

  lazyload = (entries = []) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.loadImage(entry.target)
        this.observer.unobserve(entry.target)
      }
    })
  }

  componentDidMount() {
    if (this.observer && this._refs.img) this.observer.observe(this._refs.img)
  }

  componentWillUnmount() {
    if (this.observer && this._refs.img) this.observer.disconnect(this._refs.img)
  }

  render() {
    const { src, dataSrc } = this.state
    const { width = 0, height = 0, className, style, alt, maxAlt, onClick } = this.props
    const altText = alt.substr(0, maxAlt)
    const wrapStyle = { ...style }
    if (!dataSrc && !style.backgroundColor) wrapStyle.backgroundImage = `url('${this.noImg}')`
    if (width && height) wrapStyle.paddingBottom = `${(height / width) * 100}%`
    const classNames = cx('lazy-load-img', className, { hidden: src === this.noImg })
    return (
      <div className={classNames} style={wrapStyle} ref={this.handleRef('wrap')} onClick={onClick}>
        <style jsx>{styles}</style>
        {dataSrc && (
          <img
            loading="auto"
            draggable="false"
            src={src}
            data-src={dataSrc}
            alt={altText}
            onError={this.onError}
            ref={this.handleRef('img')}
          />
        )}
        {/* image SEO for lazyload */}
        {dataSrc && (
          <noscript>
            <img src={dataSrc} alt={altText} />
          </noscript>
        )}
      </div>
    )
  }
}

export default LazyLoadImg
